import { AuthProvider } from "./contexts/AuthContext";
import Background from "./components/Background";
import CookieBanner from "./routes/CookieBanner";
import LegalBanner from "./routes/LegalBanner";
import Provider from "./components/ergo-elements/components/Provider";
import Router from "./Router";
import SessionExpiredModal from "./components/SessionExpiredModal";

function App() {
  return (
    <AuthProvider>
      <Background>
        <CookieBanner />
        <LegalBanner />
        <Provider theme="dkv" style={{ height: "100%" }}>
          <SessionExpiredModal />
          <Router />
        </Provider>
      </Background>
    </AuthProvider>
  );
}

export default App;
